/*
 * @Author: changcheng
 * @LastEditTime: 2023-12-27 10:41:57
 */
//@ts-nocheck
import "antd/dist/antd.min.css";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "@root/store/index";
import { ConfigProvider } from "antd"; // Add this line
import { persistor } from "@root/store/index";
import { registerMicroApps, start } from "qiankun";
import { PersistGate } from "redux-persist/lib/integration/react";
import { videoControlInstance } from "@root/common/video";
import App from "@root/routes/index";
import reportWebVitals from "./reportWebVitals";
import "./styles/index.scss";
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
function renderRoot() {
  root.render(
    <Provider store={store}>
      <ConfigProvider>
        <PersistGate persistor={persistor}>
          <App />
        </PersistGate>
      </ConfigProvider>
    </Provider>
  );
}
// if (window.__POWERED_BY_QIANKUN_PARENT__) {
renderRoot();
// }
// registerMicroApps([
//   {
//     name: "examPaper",
//     entry: "//localhost:3001/",
//     container: "#examPaper",
//     activeRule: "#/home/userCenter/examPaper",
//   },
// ]);
// start();

window.onCCH5PlayerLoaded = () => {
  window.ccH5PlayerJsLoaded = true;
};
videoControlInstance.initVideo(); // 初始化视频功能
reportWebVitals();
